import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {ApiReturnType} from "../../models/common/ApiReturnType";
import {AppState} from "../../reducers/RootReducer";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {getUrlParamsFromViewSettings} from "../../config/RouteConfig";
import {eventNotificationError} from "../common/EventNotificationActions";
import {  StateObservable, ofType } from "redux-observable";
import { switchMap, filter, map, catchError } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { Observable, of } from 'rxjs';
import {ProjectUserPrivileges} from "../../models/projects/ProjectUserPrivileges";
import {ProjectId, ProjectModule} from "../../models/projects/Project";
import {Identifier} from "../../models/common/Identifier";

export type ProjectPrivilegesActionTypes = FetchProjectPrivilegesActionTypes

export interface FetchProjectPrivilegesAction extends ProjectId, ReduxAction< typeof FETCH_PROJECT_PRIVILEGES > {
}
export interface FetchProjectPrivilegesSuccessAction extends ProjectId, ReduxAction<typeof FETCH_PROJECT_PRIVILEGES_SUCCESS > {
    payload: ProjectUserPrivileges
}
export interface FetchProjectPrivilegesErrorAction extends ErrorAction< typeof FETCH_PROJECT_PRIVILEGES_ERROR >{}

export type FetchProjectPrivilegesActionTypes = FetchProjectPrivilegesAction | FetchProjectPrivilegesSuccessAction | FetchProjectPrivilegesErrorAction


export const FETCH_PROJECT_PRIVILEGES = "FETCH_PROJECT_PRIVILEGES";
export const FETCH_PROJECT_PRIVILEGES_SUCCESS = "FETCH_PROJECT_PRIVILEGES_SUCCESS";
export const FETCH_PROJECT_PRIVILEGES_ERROR = "FETCH_PROJECT_PRIVILEGES_ERROR";

export const fetchProjectPrivileges = ( projectId: Identifier<number> ) : FetchProjectPrivilegesAction =>
    ({ type: FETCH_PROJECT_PRIVILEGES, projectId });
export const fetchProjectPrivilegesSuccess = ( projectId: Identifier<number>, payload: ProjectUserPrivileges ): FetchProjectPrivilegesSuccessAction =>
    ({ type: FETCH_PROJECT_PRIVILEGES_SUCCESS,  payload, projectId });
export const fetchProjectPrivilegesError = ( error: Error ): FetchProjectPrivilegesErrorAction =>
    ({ type: FETCH_PROJECT_PRIVILEGES_ERROR,  error });

export function fetchProjectPrivilegesEpic(
    action$: Observable< FetchProjectPrivilegesAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType( FETCH_PROJECT_PRIVILEGES ),
        switchMap(action => {
            const path = `${APP_CONFIG.baseWeb}projects/${ action.projectId.rawValue }/privileges`;

            return ajax( APP_CONFIG.getRequestObject( path ) ).pipe(
                map(response => fetchProjectPrivilegesSuccess(
                    action.projectId,
                    response.response as ProjectUserPrivileges
                )),
                catchError(error => of(
                    fetchProjectPrivilegesError(  error ),
                    eventNotificationError( error , error.status, ProjectModule.identifier, "fetchProjectPrivileges")
                ))
            );

        })
    );
}